require("./preGrantedCreditSuccess.scss");
require("./preGrantedCreditSuccess.override.scss");
// @vendor
const React = require("react");
const PropTypes = require("prop-types");
// @components
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const OKInformativeListItem = require("components/rebrand/OKInformativeListItem/OKInformativeListItem");
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");
// @commons
const { OKMessage } = require("commonsComponents/OKMessage");
// @core
const { formatText, FormattedText } = require("core/i18n").i18n;
// utilities
const {
    getFormattedString,
    decimalsLength,
} = require("utilities/currencyHelper");
const { getMaskedAccount } = require("../../../../loansUtilities/loansHelper");
const {
    analyticsId,
    catalogue,
} = require("../analytics/preGrantedCreditAnalytics");
const { recordPage, recordLinkV2 } = require("utilities/tagging");

class PreGrantedCreditSuccess extends React.Component {
    componentDidMount() {
        recordPage(catalogue[analyticsId.PRE_GRANTED_CREDIT_WIZARD_SUCCESS]());
        recordLinkV2(
            catalogue[analyticsId.PRE_GRANTED_CREDIT_STEP_3_SUCCESS]()
        );
    }

    buildbackButton() {
        return {
            label: formatText(
                "contractsView-errorBackButtonLabelLoans"
            ).toUpperCase(),
            url: "/myprofile/loans-mortgages",
        };
    }

    buildSummary() {
        const { immAccount, immPreGrantedCredit } = this.props;
        const account = getMaskedAccount(immAccount);

        const amount = immPreGrantedCredit.get("selectedAmount");
        const tin = <FormattedText value="contractSummary-pregrantedTIN" />;
        const tae = <FormattedText value="contractSummary-pregrantedTAE" />;

        const formatCurrency = () =>
            getFormattedString({
                amount,
                currency: immPreGrantedCredit.get("currency"),
                decimalsLength: decimalsLength(amount),
            });

        const formattedAmount = formatCurrency(amount);
        const formattedBalance = getFormattedString(immAccount.get("balance"));

        const fieldsLeft = [
            {
                title: formatText("contractSummary-requestedAmount"),
                bodyText: formattedAmount,
            },
            {
                title: formatText("contractsView-tin"),
                bodyText: tin,
            },
            {
                title: formatText("contractsView-tae"),
                bodyText: tae,
            },
        ];

        const fieldsRight = [
            {
                title: formatText("contractSummary-associatedAccount"),
                bodyText: account,
            },
            {
                title: formatText("contractSummary-balanceAssociatedAccount"),
                bodyText: formattedBalance,
            },
        ];

        const mapFields = (field, index) => {
            return <OKInformativeListItem key={`item-${index}`} {...field} />;
        };

        const itemsLeft = fieldsLeft.map(mapFields);
        const itemsRight = fieldsRight.map(mapFields);

        return (
            <div className="row">
                <div className="col-xs-5 pre-granted-credit-success__border-separator">
                    <OKInformativeList columns={1}>
                        {itemsLeft}
                    </OKInformativeList>
                </div>
                <div className="col-xs-6 col-xs-offset-1">
                    <OKInformativeList columns={1}>
                        {itemsRight}
                    </OKInformativeList>
                </div>
            </div>
        );
    }

    buildDisclaimer() {
        const { email, immFlagBasedFeatures } = this.props;
        return (
            <div className="row pre-granted-credit-success__message-section">
                <OKMessage type="informative">
                    <FormattedText
                        value="contractsView-preGrantedCreditSuccessStepMessageWithEmail"
                        injectedStrings={[email]}
                    />
                </OKMessage>
            </div>
        );
    }

    render() {
        const summary = this.buildSummary();
        const disclaimer = this.buildDisclaimer();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 pre-granted-credit-success">
                <WizardSuccess
                    successMessage={formatText(
                        "contractSummary-preGrantedCreditTitle"
                    )}
                    mainButton={this.buildbackButton()}
                >
                    {summary}
                    {disclaimer}
                </WizardSuccess>
            </div>
        );
    }
}

PreGrantedCreditSuccess.propTypes = {
    email: PropTypes.string.isRequired,
    immAccount: PropTypes.object.isRequired,
    immPreGrantedCredit: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = PreGrantedCreditSuccess;
